const ROUTES = {
  "/": {
    "name": "HomePageA6ff1abfDfde426bBce843cddcf626d1",
    "type": "HTML",
    "key": "home-page"
  },
  "/about": {
    "name": "AboutUsPageFacfd5a53bb440038eb36f148f93a763",
    "type": "HTML",
    "key": "about-us-page"
  },
  "/apply/*": {
    "name": "ApplicationPages623e4ce8Fdf94b879902875d2e78fd8b",
    "type": "REFERENCE",
    "key": "application-pages"
  },
  "/events/public": {
    "name": "PublicEventsPage2396dace29b74e96B625A2e6ee4a585d",
    "type": "HTML",
    "key": "public-events-page"
  },
  "/join": {
    "name": "JoinUsPageFd46513272024ea7B2bcA80ece8c4a7a",
    "type": "REFERENCE",
    "key": "join-us-page"
  }
};

export default ROUTES;